export interface UserDepartment {
    id: number;
    name: string;
}

export interface UserOrganization {
    id: number;
    fullName: number;
    shortName: number;
}

export enum UserRoles {
    Manager = 'manager',
    Employee = 'user',
    Admin = 'admin',
}

export enum UserStatus {
    Active = 'active',
    Disabled = 'disabled',
    WaitingActivation = 'waiting-activation',
}

export interface UserListItem {
    id: number;
    email: string;
    lastName: string;
    firstName: string;
    middleName: string;
    photoUrl: string;
    phoneNumber: string;
    company: UserOrganization | null;
    department: UserDepartment | null;
    jobTitle: string;
    receivingPromotionalMaterials: boolean;
    utmSource: string;
    active: boolean;
    emailVerified: boolean;
    role: {
        roleName: string;
        code: UserRoles;
    };
}

export interface UserPreview {
    id: number;
    email: string | null;
    emailVerified: boolean;
    lastName: string | null;
    firstName: string | null;
    middleName: string | null;
    photoUrl: string | null;
    phoneNumber: string | null;
    company: UserOrganization | null;
    department: UserDepartment | null;
    jobTitle: string | null;
    receivingPromotionalMaterials: boolean;
    utmSource: string | null;
    active: boolean;
    role: {
        roleName: string;
        code: UserRoles;
    };
}
